export default __webpack_public_path__ + "static/media/hiringArrow.19a4376b.svg";